import React from 'react';
import ReactDOM from 'react-dom';

import 'normalize.css';
import './style.css';

import App from './App';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
document.addEventListener('DOMContentLoaded', function(){
	document.querySelector('.map-holder').classList.add('show');
})



// WEBPACK FOOTER //
// ./src/index.js